



















































































































import Vue from 'vue';
import moment from 'moment';

import { GetDocumentParameters } from 'pdfjs-dist/types/src/display/api';

import { IDocumentRevision, IQuoteProductDocument } from '@/models';
import {
  ISystemError,
  ISystemErrorData,
  SystemError
} from '@/models/error/index';
import { blobToBase64 } from '@/utils/helpers';

import PDFViewer from '@/components/common/PDFViewer/PDFViewer.vue';

interface Options extends InstanceType<typeof Vue> {
  $refs: {
    pdfViewer: InstanceType<typeof PDFViewer>;
  };
}

export default Vue.extend<Options>({ functional: false }).extend({
  name: 'DocumentDetailPDFViewerDialog',

  components: {
    PDFViewer
  },

  data() {
    return {
      isActive: false,
      source: null as GetDocumentParameters | null,
      isLoading: false,
      fetchError: null as null | ISystemError,
      document: null as IQuoteProductDocument | null,
      revision: null as IDocumentRevision | null,
      page: 1,
      isPDFRendered: false
    };
  },

  methods: {
    open(document: IQuoteProductDocument, revision: IDocumentRevision) {
      // reset source if document changes
      if (this.document != document) {
        this.source = null;
        this.isPDFRendered = false;
      }
      this.document = document;
      this.revision = revision;
      this.isActive = true;
      this.page = 1;
      this.downloadDocumentRevisionFile(revision);
    },

    close() {
      this.isActive = false;
    },

    clearErrors() {
      this.fetchError = null;
    },

    downloadRevisionFile(revision: IDocumentRevision) {
      const fileName = `document-#${revision!.revision}-${moment(
        revision!.uploaded_at
      ).format('YYYY-MM-DD-HH-mm-ss')}`;
      const link = document.createElement('a');

      const linkName = `${fileName}.pdf`;

      link.href = this.source as string;

      link.setAttribute('download', linkName); //or any other extension
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
    },

    // get document revision file when opening
    downloadDocumentRevisionFile(revision: IDocumentRevision) {
      this.isLoading = true;
      this.clearErrors();
      this.$services.fileLoader
        .downloadFile(revision.file)
        .then(async data => {
          this.source = await blobToBase64(data);
        })
        .catch(error => {
          const systemErrorData: ISystemErrorData = {
            name: error.name,
            message: error.message
          };
          // TODO: LH 2024-07-23 - look into not reusing this code
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            systemErrorData.message = error.response.statusText;
            if (error.response.data.detail) {
              systemErrorData.detail = error.response.data.detail;
            }
          } else if (error.request) {
            // The request was made but no response was received (Can happen on 500 error)
            systemErrorData.detail =
              'There was an error in processing your request. Please check with IT Admin';
          }

          this.fetchError = new SystemError(systemErrorData);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    previousPage() {
      this.page = this.page - 1;
    },

    nextPage() {
      this.page = this.page + 1;
    },

    hasPrevPage(): boolean {
      return this.page != 1;
    },

    hasNextPage(): boolean {
      if (!this.$refs.pdfViewer) return false;

      const numPages = this.$refs.pdfViewer.getPages();

      return this.page < numPages;
    }
  }
});
